import type { Release } from '../releases';

export default {
  id: '2026-11-01-schedule-import-mpp-pdf',
  at: '2026-11-01T05:59:00Z',
  title: 'Загрузка графика: понятный ответ на MPP и подтверждение графика из PDF',
  modules: ['schedule'],
  items: [
    'Файл MS Project в формате MPP теперь узнаётся и тогда, когда у него другое расширение: портал сразу подсказывает сохранить график в MS Project как XML, а не пишет об ошибке чтения.',
    'Для графиков подрядчиков в PDF подготовлена загрузка с подтверждением: после «Сверить без загрузки» появится кнопка «Подтвердить и загрузить», и в график попадёт ровно то, что вы проверили. Сам разбор PDF подключит ассистент Pilot.',
  ],
  why: 'Файл MPP давал непонятную ошибку чтения, а график из PDF, прочитанный автоматически, нельзя загружать без проверки человеком.',
  link: '/schedule',
} satisfies Release;
